import { Link } from "react-router-dom";

const specialties = [
  "Colposcopia diagnóstica y digital",
  "Detección y tratamiento del VPH",
  "Cirugía ambulatoria de cuello uterino",
  "Ginecología preventiva y general",
  "Papanicolaou e interpretación avanzada",
];

export default function AboutDoctorSection() {
  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image — shown second on mobile, first on desktop */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border-4 border-teal-100 mx-auto max-w-sm lg:max-w-none">
              <img
                src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/bba9b61847c1f92c0a25fe1b0a9ecb0d.png"
                alt="Dr. Erick Tejada - Ginecólogo y Colposcopista en Ciudad de Panamá"
                className="w-full h-72 sm:h-96 md:h-[480px] object-cover object-top"
              />
            </div>
            {/* Floating card — anchored inside, no overflow */}
            <div className="absolute bottom-4 right-4 bg-white rounded-2xl px-5 py-4 border border-slate-100 max-w-[180px]">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-teal-100 flex-shrink-0">
                  <i className="ri-award-fill text-teal-600 text-base"></i>
                </div>
                <div>
                  <p className="text-slate-800 font-bold text-base leading-none" style={{ fontFamily: "'Poppins', sans-serif" }}>10+</p>
                  <p className="text-slate-500 text-xs" style={{ fontFamily: "'Poppins', sans-serif" }}>años exp.</p>
                </div>
              </div>
              <p className="text-slate-600 text-xs leading-snug" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Especialista en colposcopia y VPH
              </p>
            </div>
          </div>

          {/* Content — shown first on mobile */}
          <div className="order-1 lg:order-2">
            <span
              className="inline-flex items-center gap-2 text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-4"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-stethoscope-line"></i>
              Especialista Certificado
            </span>

            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-2"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Dr. Erick Tejada
            </h2>
            <p
              className="text-teal-600 text-base md:text-lg font-medium mb-5"
              style={{ fontFamily: "'Lora', serif" }}
            >
              Ginecólogo &amp; Colposcopista · Ciudad de Panamá
            </p>

            <p
              className="text-slate-600 text-sm md:text-base leading-relaxed mb-4"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              El Dr. Erick Tejada es un médico ginecólogo con formación especializada en colposcopia y manejo del Virus del Papiloma Humano (VPH). Su enfoque principal es la <strong>detección temprana de lesiones precancerosas</strong> y el tratamiento oportuno para proteger la salud de sus pacientes.
            </p>
            <p
              className="text-slate-600 text-sm md:text-base leading-relaxed mb-7"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Con un trato cercano y un lenguaje claro y comprensible, el Dr. Tejada guía a cada paciente en su proceso de prevención y diagnóstico, brindando tranquilidad y confianza en cada consulta en Ciudad de Panamá.
            </p>

            {/* Specialties */}
            <ul className="space-y-2.5 mb-8">
              {specialties.map((s) => (
                <li key={s} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-teal-100 flex-shrink-0">
                    <i className="ri-check-line text-teal-600 text-xs"></i>
                  </div>
                  <span
                    className="text-slate-700 text-sm"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {s}
                  </span>
                </li>
              ))}
            </ul>

            <Link
              to="/sobre-el-doctor"
              className="inline-flex items-center gap-2 border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white font-semibold px-6 py-3 rounded-full transition-all text-sm whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Conocer más sobre el Dr. Tejada
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
